// extracted by mini-css-extract-plugin
export default {"root":"FallbackPage_root__IPjrQ","content":"FallbackPage_content__MTa-S"};